import { HalfPage } from "layouts/HalfPage/HalfPage";

export default HalfPage;
